// « divers » fragment (EN): About us, Contact, customer reviews, cookie banner.
// Same keys as fr/divers.js, values in British English.
// No review, rating or sales figure is invented here: only the wrapper text is
// translated — review CONTENT comes from the database.
export default {
  // ---- About us (pages/About.jsx) ----
  'apropos.seo.titre': 'About us',
  'apropos.seo.description': 'Discover the story behind Mirum Games and our passion for creating magical family moments with Joyful Reveal, the puzzles made from quality materials.',
  'apropos.hero.badge': '🎮 Our story',
  'apropos.hero.titre': 'Welcome to Mirum Games',
  'apropos.hero.texte': 'We create magical moments to celebrate the arrival of your baby and to share that joy with the whole family.',
  'apropos.mission.titre': 'Our mission',
  'apropos.mission.texte1': 'At Mirum Games we believe that life’s big moments deserve to be celebrated in a unique and memorable way. Our mission is to create festive, interactive experiences that turn the reveal of your baby’s sex into an unforgettable moment shared with the whole family.',
  'apropos.mission.texte2': 'Every puzzle is designed with care to create a moment of suspense and joy, with outstanding quality and an experience the whole family will remember.',
  'apropos.mission.encart.titre': 'A playful celebration',
  'apropos.mission.encart.texte': 'Turning the reveal into a fun quiz that everybody joins in with',
  'apropos.mission.carte1.titre': 'Suspense',
  'apropos.mission.carte1.texte': 'Creating a memorable moment of suspense and anticipation',
  'apropos.mission.carte2.titre': 'Celebration',
  'apropos.mission.carte2.texte': 'Turning the reveal into a festive, memorable event',
  'apropos.mission.carte3.titre': 'Sharing',
  'apropos.mission.carte3.texte': 'Quality time with the family',
  'apropos.valeurs.titre': 'Our core values',
  'apropos.valeurs.soustitre': 'The principles behind every decision we make',
  'apropos.valeurs.excellence.titre': 'Excellence',
  'apropos.valeurs.excellence.texte': 'We never compromise on quality. Every detail counts, from the design to the finish of the puzzle.',
  'apropos.valeurs.creativite.titre': 'Creativity',
  'apropos.valeurs.creativite.texte': 'We keep innovating to create unique, memorable reveals that really stay with people.',
  'apropos.valeurs.authenticite.titre': 'Authenticity',
  'apropos.valeurs.authenticite.texte': 'We stay true to our values and to our commitment towards our customers and our community.',
  'apropos.valeurs.innovation.titre': 'Innovation',
  'apropos.valeurs.innovation.texte': 'We are constantly exploring new ways to create exceptional celebration experiences.',
  'apropos.valeurs.emotions.titre': 'Emotion',
  'apropos.valeurs.emotions.texte': 'We create moments full of emotion that the whole family will remember for years.',
  'apropos.valeurs.passion.titre': 'Passion',
  'apropos.valeurs.passion.texte': 'We are passionate about what we do, and you can feel it in every product.',
  'apropos.reseaux.titre': 'Our social media',
  'apropos.reseaux.soustitre': 'Join our community and go behind the scenes',
  'apropos.reseaux.instagram.texte': 'Discover our latest creations, go behind the scenes of our puzzles and share your magical moments with #MirumGames',
  'apropos.reseaux.facebook.texte': 'Join our community, take part in our competitions and stay up to date with our exclusive offers and new arrivals',
  'apropos.processus.titre': 'Our creative process',
  'apropos.processus.soustitre': 'From the idea to your home',
  'apropos.processus.etape1.titre': 'Research & ideas',
  'apropos.processus.etape1.texte': 'We listen to the feedback of parents-to-be and of everyone who hosts a gender reveal party, so we can create experiences that are even more memorable.',
  'apropos.processus.etape2.titre': 'Design & testing',
  'apropos.processus.etape2.texte': 'Our team designs every puzzle and runs thorough tests to guarantee a fun experience that stays with you.',
  'apropos.processus.etape3.titre': 'Manufacturing',
  'apropos.processus.etape3.texte': 'Every puzzle is made with care and attention to detail to guarantee premium quality.',
  'apropos.processus.etape4.titre': 'Quality & shipping',
  'apropos.processus.etape4.texte': 'Every game goes through a strict quality check before being carefully shipped to your door.',
  'apropos.cta.titre': 'Ready to explore our games?',
  'apropos.cta.texte': 'Discover our full collection and turn the reveal of your baby’s sex into a magical, unforgettable moment.',
  'apropos.cta.boutique': '🛍️ Discover the shop',
  'apropos.cta.contact': '💬 Contact us',

  // ---- Contact (pages/Contact.jsx) ----
  'contact.seo.titre': 'Contact',
  'contact.seo.description': 'Get in touch with Mirum Games with any question about Joyful Reveal, our game, or your orders. A quick reply guaranteed.',
  'contact.hero.badge': '💬 Let’s stay in touch',
  'contact.hero.titre': 'We would love to hear from you',
  'contact.hero.texte': 'Questions? Suggestions? Do get in touch. We usually reply within 24 hours.',
  'contact.cartes.email.titre': 'Email',
  'contact.cartes.email.texte': 'Reply within 24-48 h',
  'contact.cartes.adresse.titre': 'Address',
  'contact.cartes.adresse.ligne1': 'Rue de la Cortaille, 59',
  'contact.cartes.adresse.ligne2': '6800 Freux, Belgium',
  'contact.cartes.faq.titre': 'Questions?',
  'contact.cartes.faq.texte': 'Have a look at our FAQ',
  'contact.cartes.faq.soustexte': 'Instant answers',
  'contact.formulaire.titre': 'Send us a message',
  'contact.formulaire.nom': 'Your name',
  'contact.formulaire.nomPlaceholder': 'John Smith',
  'contact.formulaire.email': 'Email',
  'contact.formulaire.emailPlaceholder': 'your@email.com',
  'contact.formulaire.sujet': 'Subject',
  'contact.formulaire.sujetPlaceholder': '-- Choose a subject --',
  'contact.formulaire.sujetCommande': 'Question about my order',
  'contact.formulaire.sujetProduit': 'Question about a product',
  'contact.formulaire.sujetLivraison': 'Question about delivery',
  'contact.formulaire.sujetPartenariat': 'Partnership',
  'contact.formulaire.sujetAutre': 'Other',
  'contact.formulaire.message': 'Message',
  'contact.formulaire.messagePlaceholder': 'Your message here...',
  'contact.formulaire.envoiEnCours': '⏳ Sending...',
  'contact.formulaire.envoyer': '📬 Send the message',
  'contact.formulaire.succes': '✨ Thank you for your message! We will get back to you very soon.',
  'contact.faq.titre': 'Frequently asked questions',
  'contact.faq.soustitre': 'You might well find your answer here',
  'contact.faq.q1': '❓ How long does delivery take?',
  'contact.faq.a1': "Orders leave Belgium within one working day on average. Then allow 1 to 2 working days for Luxembourg, Belgium and the Netherlands, 2 to 4 days for France and Germany, and 4 to 5 days for Spain.",
  'contact.faq.q2': '🎁 Can I add a personalised message?',
  'contact.faq.a2': 'Of course! Our premium packs include a personalised card. Get in touch after your order for the details.',
  'contact.faq.q3': '💰 Is there a guarantee?',
  'contact.faq.a3': 'Yes! You have 14 days to return a product that is not right for you. On top of that, we guarantee all our products against hidden defects.',
  'contact.faq.q4': '🌍 Do you ship internationally?',
  'contact.faq.a4': "We deliver to Belgium, France, Luxembourg, the Netherlands, Germany and Spain. At checkout you choose between home delivery and a pick-up point, depending on the carriers available at your address.",
  'contact.faq.q5': '🎮 How does the puzzle work?',
  'contact.faq.a5': 'It is a fun quiz that guides you through building the puzzle. Answer correctly, put the pieces together and discover your baby’s sex!',
  'contact.faq.q6': '🎊 How many people can play?',
  'contact.faq.a6': 'The puzzle is made to be shared with the family! You can form teams and play with as many people as you like to make the moment even more festive.',
  'contact.newsletter.titre': 'Stay in the loop',
  'contact.newsletter.texte': 'Sign up to our newsletter to receive our latest offers and news',
  'contact.newsletter.emailPlaceholder': 'your@email.com',
  'contact.newsletter.inscrire': 'Sign up',
  'contact.newsletter.succes': '✨ Welcome to our newsletter!',

  // ---- Customer reviews (components/Reviews/*) ----
  // The CONTENT of the reviews (text, title, author name) comes from the
  // database and is never translated; only the wrapper uses these keys.
  'avis.section.badge': '💬 Customer experiences',
  'avis.section.titre': 'What our customers love',
  'avis.section.accrocheAucun': 'Played it already? Tell us about your moment — your review will help the next parents-to-be make up their minds.',
  'avis.section.accrochePeu': 'They played before you and took the time to write to us. Here are their words, unfiltered.',
  'avis.section.accrocheNombreux': 'Already {n} families have shared their moment with us.',
  'avis.section.compteurSingulier': 'review',
  'avis.section.compteurPluriel': 'reviews',
  'avis.section.premierAvis': 'Be the first to leave a review!',
  'avis.section.fermer': '✕ Close',
  'avis.section.laisserAvis': '✍️ Leave a review',
  'avis.section.chargement': 'Loading reviews...',
  'avis.section.listeTitre': 'The reviews',
  'avis.section.aucunTitre': 'Be the first!',
  'avis.section.aucunTexte': 'No reviews yet. Be the first to share your magical experience!',
  'avis.section.ecrirePremier': 'Write the first review',
  'avis.section.erreurEnvoi': 'Something went wrong while sending the review',
  'avis.carte.noteAria': 'Rating of {note} out of 5',
  'avis.carte.clientVerifie': 'Verified customer',
  'avis.carte.achatVerifie': '✅ Verified purchase',
  'avis.formulaire.titre': 'Share your experience',
  'avis.formulaire.note': 'Overall rating',
  'avis.formulaire.noterAria': 'Give {n} stars',
  'avis.formulaire.note5': 'Excellent! 🤩',
  'avis.formulaire.note4': 'Very good 🙂',
  'avis.formulaire.note3': 'Good 😐',
  'avis.formulaire.note2': 'Average 😕',
  'avis.formulaire.note1': 'Disappointed 😞',
  'avis.formulaire.titreAvis': 'Title of your review',
  'avis.formulaire.titrePlaceholder': 'E.g.: Great puzzle, my daughter loves it!',
  'avis.formulaire.commentaire': 'Your comment',
  'avis.formulaire.commentairePlaceholder': 'Tell us what you liked...',
  'avis.formulaire.envoiEnCours': 'Sending...',
  'avis.formulaire.publier': 'Publish my review',

  // ---- Cookie banner (components/CookieConsent.jsx) ----
  'cookies.bandeau.titre': '🍪 Cookie settings',
  'cookies.bandeau.texte': "This site uses only two things: the cookies your basket and your login need, and an anonymous audience measurement, run by us, with no cookie and without ever identifying you. No advertising, no profiling, nothing shared with a third party.",
  'cookies.gerer': "Manage my cookies",
  'cookies.categories.necessaires': 'Necessary cookies',
  'cookies.categories.necessairesDesc': 'Always on - Essential for the site to work',
  'cookies.categories.analytics': "Anonymous audience measurement",
  'cookies.categories.analyticsDesc': "Number of visits and pages viewed. No cookie, no identifier, your IP address is never kept. You may refuse it.",
  'cookies.categories.marketing': 'Marketing cookies',
  'cookies.categories.marketingDesc': 'To offer you personalised content and offers',
  'cookies.bandeau.voirNotre': 'See our',
  'cookies.bandeau.politique': 'Privacy Policy',
  'cookies.bandeau.plusInfos': 'for more information',
  'cookies.actions.refuser': 'Reject all',
  'cookies.actions.personnaliser': 'Customise',
  'cookies.actions.accepter': 'Accept all',

  // --- Connexion, inscription, profil ---
  // Ces trois pages n'etaient pas traduites du tout : un visiteur allemand
  // cliquait « Anmelden » dans une barre de navigation allemande et recevait
  // un formulaire entierement francais.
  'compte.connexion.seoTitre': "Sign in",
  'compte.connexion.seoDescription': "Sign in to your Mirum Games account.",
  'compte.connexion.titre': "Sign in",
  'compte.connexion.sousTitre': "Welcome to Mirum Games",
  'compte.champ.email': "Email address",
  'compte.champ.emailPlaceholder': "your@email.com",
  'compte.champ.motDePasse': "Password",
  'compte.champ.motDePassePlaceholder': "Your password",
  'compte.champ.basculerMotDePasse': "Show or hide the password",
  'compte.connexion.seSouvenir': "Remember me",
  'compte.connexion.motDePasseOublie': "🔑 Forgot your password?",
  'compte.connexion.bouton': "🔓 Sign in",
  'compte.connexion.enCours': "⏳ Signing in…",
  'compte.connexion.ouContinuerAvec': "Or continue with",
  'compte.connexion.pasDeCompte': "Don't have an account yet?",
  'compte.connexion.creerUnCompte': "Create an account",
  'compte.connexion.erreur': "Invalid credentials. Please try again.",
  'compte.connexion.erreurGoogle': "Something went wrong signing in with Google.",
  'compte.inscription.seoTitre': "Sign up",
  'compte.inscription.seoDescription': "Create your Mirum Games account.",
  'compte.inscription.titre': "Sign up",
  'compte.inscription.sousTitre': "Join the Mirum Games community",
  'compte.champ.nomComplet': "Full name",
  'compte.champ.nomCompletPlaceholder': "Jane Smith",
  'compte.champ.creerMotDePasse': "Create a secure password",
  'compte.champ.confirmation': "Confirm password",
  'compte.champ.confirmationPlaceholder': "Confirm your password",
  'compte.force.faible': "❌ Weak",
  'compte.force.moyen': "⚠️ Medium",
  'compte.force.fort': "✅ Strong",
  'compte.inscription.accepteLes': "I accept the",
  'compte.inscription.conditions': "terms and conditions of sale",
  'compte.inscription.etLa': "and the",
  'compte.inscription.politique': "privacy policy",
  'compte.inscription.bouton': "🎮 Create an account",
  'compte.inscription.enCours': "⏳ Creating your account…",
  'compte.inscription.dejaUnCompte': "Already have an account?",
  'compte.inscription.seConnecter': "Sign in",
  'compte.inscription.erreurMotsDePasse': "The passwords do not match.",
  'compte.inscription.erreurConditions': "Please accept the terms and conditions.",
  'compte.inscription.erreurLongueur': "The password must be at least 6 characters long.",
  'compte.inscription.erreur': "Something went wrong during sign-up. Please try again.",
  'compte.profil.deconnexion': "Sign out",
  'compte.profil.mesCommandes': "📦 My orders",
  'compte.profil.informations': "👤 Details",
  'compte.profil.informationsTitre': "Personal details",
  'compte.commandes.chargement': "Loading your orders…",
  'compte.commandes.aucune': "You haven't placed an order yet.",
  'compte.commandes.decouvrir': "Browse our products",
  'compte.commandes.articles': "Items:",
  'compte.commandes.total': "Total:",
  'compte.commandes.suiviLabel': "Tracking no.:",
  'compte.commandes.suivre': "Track my parcel",
  'compte.commandes.facture': "Download the invoice",
  "compte.commandes.noteCredit": "Credit note",
  'compte.commandes.avis': "Leave a review",
  'compte.commandes.nonAuthentifie': "Your session has expired. Please sign in again.",
  'compte.commandes.erreur': "Something went wrong while loading your orders",
  'compte.statut.paid': "Paid",
  'compte.statut.shipped': "Shipped",
  'compte.statut.delivered': "Delivered",
  'compte.statut.cancelled': "Cancelled",
  'compte.infos.general': "General information",
  'compte.infos.nomComplet': "Full name *",
  'compte.infos.emailFige': "The email address cannot be changed",
  'compte.infos.adresseLivraison': "Delivery address",
  'compte.infos.adresse': "Address",
  'compte.infos.adressePlaceholder': "Street number and name",
  'compte.infos.ville': "City",
  'compte.infos.codePostal': "Postcode",
  'compte.infos.pays': "Country",
  'compte.infos.choisirPays': "Choose a country",
  'compte.infos.telephone': "Phone",
  'compte.infos.enregistrer': "💾 Save",
  'compte.infos.enregistrement': "⏳ Saving…",
  'compte.infos.succes': "✅ Your profile has been updated.",
  'compte.infos.erreur': "❌ Something went wrong while updating your profile",
  "maFacture.seoTitre": "Find my invoice - Mirum Games",
  "maFacture.seoDescription": "Find the invoice for your Mirum Games order with your order number and email address.",
  "maFacture.titre": "Find my invoice",
  "maFacture.intro": "Ordered without an account and can't find the confirmation email? Enter your order number and the email address you used for the purchase.",
  "maFacture.champNumero": "Order or invoice number",
  "maFacture.champNumeroAide": "You'll find it in the confirmation email and on the page shown after payment.",
  "maFacture.champEmail": "Email address used for the purchase",
  "maFacture.bouton": "Find my invoice",
  "maFacture.recherche": "Searching…",
  "maFacture.introuvable": "We can't find an order matching these details. Check the number and the email address used for the purchase.",
  "maFacture.tropDEssais": "Too many attempts in a row. Please wait a minute, then try again.",
  "maFacture.erreur": "The search didn't go through. Try again in a moment or write to us.",
  "maFacture.facture": "Your invoice no. {numero} is ready.",
  "maFacture.voirFacture": "🧾 View and print the invoice",
  "maFacture.langueDocument": "The invoice is in French. You can print it or save it as a PDF from your browser.",
  "maFacture.factureStripe": "🧾 View the invoice for this order",
  "maFacture.enAttente": "Your payment hasn't arrived yet: we'll email you the invoice as soon as it does.",
  "maFacture.aucune": "This order has no online invoice. Write to us and we'll send it to you.",
  "maFacture.voirNote": "Credit note no. {numero}",
  "maFacture.compte": "Have an account? All your invoices are in",
};
